<template>
  <div>
    <div class="top">
      <h2 style="text-align:left;">
        <div style="display: inline-block">
            <span style="font-size: 24px;" v-if="userInfo.organization&&userInfo.organization.bool_leader">
              {{ userInfo.team_name }}
            </span>
          <span style="color: #606266">经营概况
            (
            <div style="display: inline-block" v-if="searchCondition.time_type!=='all'">
               <span v-if="searchCondition.year">{{ searchCondition.year }}年</span>
                <span v-if="searchCondition.month">{{ searchCondition.month }}月</span>
            </div>
            <div style="display: inline-block" v-else>
              全部
            </div>
            )
          </span>
        </div>

        <div class="date">
          <span :class="activeTab === 1 ?'active dateItem':'dateItem'" @click="selectLastMonth(0,1)">本月</span>
          <span :class="activeTab === 2 ?'active dateItem':'dateItem'" @click="selectLastMonth(-1,2)">上月</span>
          <span :class="activeTab === 3 ?'active dateItem':'dateItem'" @click="selectYear(0,3)">本年</span>
          <span :class="activeTab === 4 ?'active dateItem':'dateItem'" @click="selectAll(4)">全部</span>
        </div>

        <div style="display: inline-block;margin-right: 10px">
          <MonthSelectGroup @selected="selectedMonth"/>
        </div>
        <div style="display: inline-block;margin-right: 10px">
          <YearSelectGroup @selected="selectedYear"/>
        </div>
      </h2>
      <div class="header">
        <div class="item item1">
          <div class="left">订单总数
            <el-tooltip class="item" effect="dark" content="以“下单时间”维度，统计不包含冲账订单" placement="top-start">
              <i class="el-icon-info" style="cursor: pointer;"/>
            </el-tooltip>
          </div>
          <div class="line"></div>
          <div class="amount">
            <div class="total">{{ summaryData.order_count ? summaryData.order_count : 0 }}</div>
          </div>
        </div>
        <div class="item item2">
          <div class="left">订单总金额（¥）
            <el-tooltip class="item" effect="dark" content="以“下单时间”维度，包含冲账订单" placement="top-start">
              <i class="el-icon-info" style="cursor: pointer;"/>
            </el-tooltip>
          </div>
          <div class="line"></div>
          <div class="amount">
            <div class="total">{{ formatNumber(summaryData.payment_account) }}</div>
          </div>
        </div>
      </div>

      <template v-if="this.userAuth.show_summary_executor">
        <!-- 执行-未执行订单-已执行未结款  --start -->
        <div class="main">
          <div class="main-item">
            <UnExecOrderTable :year="searchCondition.year" :month="searchCondition.month"
                              :time-type="searchCondition.time_type"/>
          </div>
          <div class="main-item">
            <ExecUnsettledOrderTable :year="searchCondition.year" :month="searchCondition.month"
                                     :time-type="searchCondition.time_type"/>
          </div>
        </div>
        <!-- 执行-未执行订单-已执行未结款  --end -->
      </template>
      <template v-if="this.userAuth.show_summary_sale">
        <!-- 销售-客户-已执行未结款  --start -->
        <div class="main">
          <div class="main-item">
            <CustomerRecordTable :year="searchCondition.year" :month="searchCondition.month"
                                 :time-type="searchCondition.time_type"/>
          </div>
          <div class="main-item">
            <UnsettledFundOrderTable :year="searchCondition.year" :month="searchCondition.month"
                                     :time-type="searchCondition.time_type"/>
          </div>
        </div>
        <!-- 销售-客户-已执行未结款  --end -->
      </template>
    </div>

  </div>
</template>

<script>
import {getSaleExcuData} from "@/api/home";
import {gFunc} from "@/globalFunc";
import UnExecOrderTable from "@/components/summary/myDashboard/saleDashboard/UnExecOrderTable";
import ExecUnsettledOrderTable from "@/components/summary/myDashboard/saleDashboard/ExecUnsettledOrderTable";
import CustomerRecordTable from "@/components/summary/myDashboard/saleDashboard/CustomerRecordTable";
import UnsettledFundOrderTable from "@/components/summary/myDashboard/saleDashboard/UnsettledFundOrderTable";

export default {
  name: "MySummary",
  components: {
    UnsettledFundOrderTable,
    CustomerRecordTable,
    ExecUnsettledOrderTable,
    UnExecOrderTable,
  },
  data() {
    return {
      year: parseInt(gFunc.parseTime(new Date(), '{y}')),
      month: parseInt(gFunc.parseTime(new Date(), '{m}')),
      activeTab: 1,
      recordForm: {
        follow_timestamp: "",
        record_content: "",
        customer_id: ""
      },
      // permission: [], //permission: summary  excu  sale
      summaryData: {},
      searchCondition: {
        year: null,
        month: null,
        name: null,
        time_type: 'not_all',
        start_time: 0,
        end_time: 0,
        // bool_exec: 2
      },
    };
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    userInfo() {
      return this.$store.getters.getUser;
    },
  },
  created() {
    this.searchCondition.year = this.year
    this.searchCondition.month = this.month
    this.searchCondition.time_type = "not_all"

    this.search()
  },
  methods: {
    formatNumber(val) {//格式化数据
      return this.gFunc.numberFormat(val, 2)
    },
    selectedYear(val) {
      this.searchCondition.time_type = "not_all";
      this.activeTab = null
      this.searchCondition.year = val.year + ''
      this.searchCondition.month = null
      this.search()
    },
    selectedMonth(val) {
      this.searchCondition.time_type = "not_all";
      this.activeTab = null
      this.searchCondition.year = val.year + ''
      this.searchCondition.month = val.month
      this.search()
    },
    selectYear(offset, activeTab) {
      this.searchCondition.time_type = "not_all";
      this.activeTab = activeTab
      let date = new Date()
      this.searchCondition.year = date.getFullYear() + offset
      this.searchCondition.month = null
      this.search()
    },
    selectLastMonth(offset, activeTab) {
      this.searchCondition.time_type = "not_all";
      this.activeTab = activeTab
      let date = new Date()
      //分页页面-默认上月
      date.setMonth(date.getMonth() + offset)
      let year = date.getFullYear() + ''
      let month = date.getMonth() + 1;
      this.searchCondition.year = year
      this.searchCondition.month = month

      this.search()
    },
    selectAll(activeTab) {
      this.activeTab = activeTab
      this.searchCondition.time_type = "all";
      // this.searchCondition.year = null;
      // this.searchCondition.month = null;

      this.search()
    },
    search() {
      let cond = this.handleSearchCondition();
      this.getsummaryData(cond);
    },
    handleSearchCondition() {
      let condition = {}

      if (this.searchCondition.time_type) {
        condition.time_type = this.searchCondition.time_type
      }

      if (this.searchCondition.year) {
        let year = this.searchCondition.year
        let month = this.searchCondition.month
        if (month) {
          month = parseInt(month)
          let day = new Date(parseInt(year), month, 0);
          let daycount = day.getDate();//最后一天
          condition.start_time = year + '-' + (month > 9 ? month : '0' + month) + '-01'
          condition.end_time = year + '-' + (month > 9 ? month : '0' + month) + '-' + daycount
        } else {
          condition.start_time = year + '-01-01'
          condition.end_time = year + '-12-31'
        }

        //时间转成时间戳
        // condition.start_time = (new Date(condition.start_time).getTime()) / 1000
        // condition.end_time = (new Date(condition.end_time).getTime()) / 1000
      }

      return condition
    },

    //汇总数据
    getsummaryData(data) {
      getSaleExcuData(data).then(res => {
        this.summaryData = res.model;
      });
    },
  }
}
</script>

<style scoped lang="scss">
.date {
  display: inline-block;
  margin-left: 50px;
}

.dateItem {
  font-size: 14px;
  font-weight: 400;
  color: rgba(50, 50, 50, 1);
  display: inline-block;
  margin: 0 15px;
  cursor: pointer;
}

/*ff3176*/
.active {
  padding: 5px 10px;
  /*background: rgba(50, 150, 255, 1);*/
  background: #ff3176;
  border-radius: 2px;
  color: #fff;
}

.homeContent {
  background: #f3f3f3;
  padding: 10px 16px;
  /*margin-top: 70px;*/
  box-sizing: border-box;
  min-height: calc(100vh - 70px);
}

.header {
  display: grid;
  grid-gap: 23px;
  grid-template-columns: repeat(2, 49%);
  grid-template-rows: repeat(1, 180px);
}

.item {
  border-radius: 4px;
  display: flex;
  color: white;
  align-items: center;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
}

.item .left {
  font-size: 14px;
  padding-left: 15%;
  padding-right: 8%;
  display: flex;

  i {
    margin-left: 4px;
  }
}

.item .line {
  width: 1px;
  height: 50%;
  background: white;
}

.item .amount {
  padding-left: 15%;
  text-align: left;
  min-width: 180px;
}

.item .amount .total {
  font-size: 36px;
  font-weight: 500;
}

.item .amount .week {
  font-size: 12px;
  margin-top: 16px;
}

.item1 {
  background-image: url("../../../assets/images/2.png");
}

.item2 {
  background-image: url("../../../assets/images/1.png");
}

.item3 {
  background-image: url("../../../assets/images/3.png");
}

.main {
  display: grid;
  margin-top: 20px;
  grid-template-columns: repeat(2, 49.3%);
  /* grid-template-rows: repeat(1, 180px); */
  grid-gap: 16px;
}

.main-item {
  background: #fff;
  border-radius: 4px;
  padding: 40px;
  text-align: left;
}

.title .i {
  background: #e03f3d;
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: 5px;
}

.forms {
  margin-top: 20px;
}

.el-input-m {
  width: 80%;
}

.noPermisson {
  margin-top: 10%;
}

.noPer {
  width: 173px;
  height: 134px;
}
</style>
